import { useEffect, useMemo, useState } from "react";
import { VLNoActionModal } from "views/uikit/VLModal";
import styles from "./style.module.scss";

function isChromeBrowser(): boolean {
  if (typeof navigator === "undefined") return true; // SSR safety

  // Prefer User-Agent Client Hints when available
  const navAny = navigator as any;
  const uaData = navAny.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    const brands: Array<{ brand: string; version: string }> = uaData.brands;
    const brandNames = brands.map((b) => (b.brand || "").toLowerCase());
    const isChrome = brandNames.some((b) => {
      const name = (b || "").toLowerCase();
      return name.includes("google chrome") || name.includes("chromium");
    });
    return isChrome;
  }

  // Fallback to userAgent sniffing
  const ua = navigator.userAgent || "";
  const isChrome = /Chrome\//.test(ua);
  const isIOSChrome = /CriOS\//.test(ua);
  return isChrome || isIOSChrome;
}

const BrowserSupportModal = () => {
  const [show, setShow] = useState(false);

  // Compute once on mount
  const isChrome = useMemo(() => {
    try {
      return isChromeBrowser();
    } catch (e) {
      return true; // Fail-open to avoid blocking unexpectedly
    }
  }, []);

  useEffect(() => {
    // Show the modal if NOT Chrome
    if (!isChrome) {
      setShow(true);
    }
  }, [isChrome]);

  return (
    <VLNoActionModal
      isOpen={show}
      variant="info"
      onClose={() => setShow(false)}
      headers={{ title: "Unsupported browser" }}
    >
      <span className={styles.message}>
        For the best experience, this application currently supports only
        <b> Google Chrome</b> desktop browser.
      </span>
    </VLNoActionModal>
  );
};

export default BrowserSupportModal;
